import {keepPreviousData, useInfiniteQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../../../utils/api-client';

export const QUERY_RESULTS_LIST_PAGE_SIZE = 100;

const getFindConnectionQueryResults = (queryId: number, cursor?: number | null) => {
    return apiClient.get<PageResponse<ConnectionDto, number>>({
        path: `queries-service/api/queries/${queryId}/connections`,
        query: {limit: QUERY_RESULTS_LIST_PAGE_SIZE, cursor}
    });
};

interface Props {
    queryId?: number;
    enabled: boolean;
}

type PageParam = {cursor: number | null};

export function useQueryResultsListInfiniteQuery(props: Props) {
    return useInfiniteQuery({
        queryKey: ['query-results-list', props.queryId],
        queryFn: ({pageParam}) =>
            getFindConnectionQueryResults(props.queryId!, (pageParam as PageParam).cursor),
        getNextPageParam: ({remaining, nextCursor}) => {
            const hasNextPage = remaining > 0;

            if (hasNextPage) {
                return {cursor: nextCursor};
            }
            return undefined;
        },
        placeholderData: keepPreviousData,
        initialPageParam: {cursor: null} as PageParam,
        enabled: !!props.queryId && props.enabled
    });
}
